import styled from 'styled-components';

import { BoxShadow, Color, FontWeight } from '../../../../enums';
import { StyledComponent } from '../../../../interfaces';
import { MenuPosition } from '../../../menuPosition/menuPosition.component';

import { ContainerProps, DropdownMenuProps } from './iconButton.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: relative;
  transition: 0.3s;
  background-color: ${({ $active }: ContainerProps): Color => $active ? Color.White : Color.Transparent};
  flex-shrink: 0;
  cursor: pointer;
`;

export const DropdownMenu: StyledComponent<'div', DropdownMenuProps> = styled.div<DropdownMenuProps>`
  box-shadow: ${BoxShadow.BackgroundShadow};
  border-radius: 4px;
  background-color: ${Color.White};
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  transition: 0.5s;
  overflow: hidden;
  padding: ${({ $visible }: DropdownMenuProps): string => $visible ? '16px 0' : '0'};
  max-height: ${({ $visible }: DropdownMenuProps): string => $visible ? '600px' : '0'};
`;

export const DropdownMenuPositionWrapper: StyledComponent<'div'> = styled.div``;

export const DropdownMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  display: flex;
  align-items: center;
  padding: 12px 40px 12px 24px;
  transition: 0.3s;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: ${Color.Gray100};
  }
`;

export const DropdownMenuPositionLabel: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  margin-left: 10px;
  white-space: nowrap;
`;
